__webpack_require__.p = "https://app.alzura-design-manager.com/build/main/js/";